<template>
  <tr>
    <td>{{company.name}}</td>
    <td>
      <a :href="company.corporate_url" target="_blank">{{company.corporate_url}}</a>
    </td>
    <td>
    </td>
    <td>
      <a :href="`/company/${company.company_id}`">編集</a>
    </td>
  </tr>
</template>
<script>

  export default {
    props: {
      company: {
        type: Object,
        default: () => {
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ListRow.vue?7c8147dd